<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <router-link
                class="btn btn-sm btn-outline-dark"
                :to="{ name: 'inventario-tarima-editar', params: { id: tarimaId } }"
              >
                <i class="fa fa-reply"></i>
                Volver a Tarima
              </router-link>
              <h5 class="form-header">
                Movimientos de Inventario por Ruta Tarima
                <u>#{{ tarimaNumero }}</u>
                <div class="st-meta float-right">
                  <div class="element-actions">
                    <button
                      v-for="paso in pasosParaBotonesMovimiento"
                      :key="`btn-paso-page-${paso.paso_key}`"
                      class="btn btn-sm btn-pill px-3 mr-1 mb-1"
                      :class="{
                        'btn-info': pasoSeleccionadoKey === paso.paso_key,
                        'btn-outline-info': pasoSeleccionadoKey !== paso.paso_key
                      }"
                      @click="seleccionarPasoMovimiento(paso.paso_key)"
                    >
                      Paso {{ paso.paso_orden }}
                    </button>
                    <small v-if="cargando" class="text-muted font-weight-bold ml-2" role="status">
                      <i class="fas fa-spinner fa-spin mr-1"></i> Cargando...
                    </small>
                  </div>
                </div>
              </h5>

              <div v-if="grupoMovimientoActivo" class="row mb-2">
                <div class="col-sm-12">
                  <small class="text-muted">
                    <strong>{{ grupoMovimientoActivo.paso_nombre }}</strong>
                    <span
                      class="ml-2 badge badge-success"
                      v-if="grupoMovimientoActivo.paso_estado === 'completado'"
                    >Completado</span>
                    <span
                      class="ml-2 badge badge-info"
                      v-else-if="grupoMovimientoActivo.paso_estado === 'en_curso'"
                    >En curso</span>
                    <span class="ml-2 badge badge-secondary" v-else>Pendiente</span>
                    <span v-if="grupoMovimientoActivo.paso_fecha" class="ml-2">
                      {{ grupoMovimientoActivo.paso_fecha }}
                    </span>
                    <span v-if="docentrySeleccionadoTexto" class="ml-2">
                      <i class="fas fa-file-invoice mr-1"></i>
                      {{ docentrySeleccionadoTexto }}
                    </span>
                  </small>
                </div>
              </div>
              <div class="row align-items-end py-4">
                <div class="col-sm-6">
                  <div class="form-group mb-sm-0"> <!-- mb-sm-0 quita el margen inferior en pantallas grandes para alinear perfecto -->
                    <label>Buscar por SKU o producto</label>
                    <input
                      v-model="filtroMovimiento"
                      type="text"
                      class="form-control"
                      placeholder="Buscar por SKU o producto..."
                    />
                  </div>
                </div>
                <!-- Agregamos col-sm-6 y utilidades flexbox (d-flex, justify-content-end) -->
                <div class="col-sm-6 d-flex justify-content-end">
                  <div class="form-group mb-0"> <!-- Envolvemos en un form-group vacío o con mb-0 para mantener la consistencia de altura -->
                    <button
                      v-if="groupSalidaId"
                      class="btn btn-sm btn-info mr-1"
                      @click="abrirSalidaTraslado(groupSalidaId)"
                    >
                      <i class="fas fa-sign-out-alt mr-1"></i> Salida
                    </button>
                    <button
                      v-if="groupEntradaId"
                      class="btn btn-sm btn-success"
                      @click="abrirEntradaTraslado(groupEntradaId)"
                    >
                      <i class="fas fa-sign-in-alt mr-1"></i> Entrada
                    </button>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>SKU</th>
                      <th>Producto</th>
                      <th class="text-right">Cant. Salida</th>
                      <th>Posición Salida</th>
                      <th class="text-right">Cant. Entrada</th>
                      <th>Posición Entrada</th>
                      <th class="text-right">Inconsistencia</th>
                      <th class="text-center">Estado</th>
                    </tr>
                  </thead>
                  <tbody v-if="grupoMovimientoActivo">
                    <tr
                      v-for="mov in grupoMovimientoActivo.items"
                      :key="`mov-page-${grupoMovimientoActivo.paso_key}-${mov.sku}-${mov.posicion_salida}-${mov.posicion_entrada}`"
                    >
                      <td>{{ mov.sku }}</td>
                      <td>{{ mov.producto }}</td>
                      <td class="text-right bolder nowrap" style="font-weight: 500">
                        <span style="color: #0646bf">
                          <i class="fas fa-truck-loading"></i>
                          {{ mov.cantidad_salida }}
                        </span>
                      </td>
                      <td>{{ mov.posicion_salida }}</td>
                      <td class="text-right bolder nowrap" style="font-weight: 500">
                        <span class="text-success">
                          <i class="fas fa-plus"></i>
                          {{ mov.cantidad_entrada }}
                        </span>
                      </td>
                      <td>{{ mov.posicion_entrada }}</td>
                      <td class="text-right bolder nowrap" style="font-weight: 500">
                        <span
                          v-bind:class="{
                            'text-danger': mov.inconsistencia > 0,
                          }"
                        >{{ mov.inconsistencia }}</span>
                      </td>
                      <td class="text-center">
                        <span
                          class="status-pill smaller green"
                          v-if="mov.estado == 'A'"
                        ></span>
                        <span
                          class="status-pill smaller red"
                          v-if="mov.estado == 'B'"
                        ></span>
                        <span
                          class="status-pill smaller red"
                          v-if="mov.estado == '9'"
                        ></span>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="8" class="text-center text-muted py-4">
                        No hay movimientos de salida/entrada registrados para mostrar.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";

export default {
  data() {
    return {
      tarimaId: null,
      tarimaNumero: null,
      movimientosRutaAgrupados: [],
      filtroMovimiento: "",
      pasoSeleccionadoKey: null,
      cargando: false,
    };
  },
  computed: {
    grupoMovimientoActivo() {
      const filtrados = this.movimientosRutaAgrupadosFiltrados;
      return filtrados.length ? filtrados[0] : null;
    },
    movimientosRutaAgrupadosFiltrados() {
      const termino = (this.filtroMovimiento || "").trim().toLowerCase();
      if (!this.pasoSeleccionadoKey) return [];

      const grupos = this.movimientosRutaAgrupados.filter(
        (grupo) => grupo.paso_key === this.pasoSeleccionadoKey
      );
      if (!termino) return grupos;

      return grupos
        .map((grupo) => ({
          ...grupo,
          items: grupo.items.filter((mov) =>
            String(mov.sku || "").toLowerCase().includes(termino) ||
            String(mov.producto || "").toLowerCase().includes(termino)
          ),
        }))
        .filter((grupo) => grupo.items.length > 0);
    },
    pasosParaBotonesMovimiento() {
      return [...this.movimientosRutaAgrupados].sort(
        (a, b) => Number(a.paso_orden || 0) - Number(b.paso_orden || 0)
      );
    },
    docentrySeleccionadoTexto() {
      const docentry = this.grupoMovimientoActivo && this.grupoMovimientoActivo.docentry;
      if (docentry === null || docentry === undefined || docentry === "") {
        return "";
      }
      return `DocEntry SAP: ${docentry}`;
    },
    firstMovementOfActiveGroup() {
      const items = this.grupoMovimientoActivo ? this.grupoMovimientoActivo.items : [];
      return items && items.length ? items[0] : null;
    },
    groupSalidaId() {
      const mov = this.firstMovementOfActiveGroup;
      return mov && mov.salida_ids && mov.salida_ids.length ? mov.salida_ids[0] : null;
    },
    groupEntradaId() {
      const mov = this.firstMovementOfActiveGroup;
      return mov && mov.entrada_ids && mov.entrada_ids.length ? mov.entrada_ids[0] : null;
    },
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.tarimaId = id;
      this.cargarMovimientos(id);
      this.cargarInfoTarima(id);
    }
  },
  methods: {
    cargarInfoTarima(tarimaId) {
      DynamicService.getById("wms", "tarima", tarimaId)
        .then((response) => {
          this.tarimaNumero = response.data.numero || null;
        })
        .catch(() => {});
    },
    cargarMovimientos(tarimaId, pasoKey) {
      if (!tarimaId) return;
      this.cargando = true;
      DynamicService.getAction("wms", "tarima", tarimaId, "movimientos_ruta", {})
        .then((response) => {
          const grupos = response.data.grupos || [];
          this.movimientosRutaAgrupados = grupos;
          if (grupos.length) {
            if (pasoKey && grupos.some((g) => g.paso_key === pasoKey)) {
              this.pasoSeleccionadoKey = pasoKey;
            } else {
              this.pasoSeleccionadoKey = grupos[0].paso_key;
            }
          } else {
            this.pasoSeleccionadoKey = null;
          }
        })
        .catch(() => {
          this.movimientosRutaAgrupados = [];
          this.pasoSeleccionadoKey = null;
          Notifications.alert.error(
            "Movimientos de Inventario",
            "No fue posible cargar los movimientos de la ruta."
          );
        })
        .finally(() => {
          this.cargando = false;
        });
    },
    seleccionarPasoMovimiento(pasoKey) {
      this.pasoSeleccionadoKey = pasoKey;
    },
    abrirSalidaTraslado(salidaId) {
      if (!salidaId) return;
      const ruta = this.$router.resolve({
        name: "inventario-salida_traslado-editar",
        params: { id: salidaId },
      });
      window.open(ruta.href, "_blank", "noopener,noreferrer");
    },
    abrirEntradaTraslado(entradaId) {
      if (!entradaId) return;
      const ruta = this.$router.resolve({
        name: "inventario-entrada_traslado-editar",
        params: { id: entradaId },
      });
      window.open(ruta.href, "_blank", "noopener,noreferrer");
    },
  },
};
</script>
